"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Pagination = /** @class */ (function () {
    function Pagination(data) {
        this.skip = data.skip;
        this.limit = data.limit;
        this.count = data.count;
        this.nextPage = data.nextPage;
        this.totalCount = data.totalCount;
    }
    return Pagination;
}());
exports.Pagination = Pagination;
//# sourceMappingURL=pagination.class.js.map